module.exports = __webpack_public_path__ + "static/media/super_pack_en_chien_printemps.73c62ddc.png";